import DispensaryProductPage from 'src/dispensary/product';
import { DispensaryProductLayout } from 'src/components/layouts/dispensary-product-layout';
import { withLayout } from 'src/components/layouts/with-layout';
import { getCacheableSearchVisibilityServerSideProps } from 'src/utils/ssr/get-dispensary-server-side-props';

export const getServerSideProps = getCacheableSearchVisibilityServerSideProps;

export default withLayout(DispensaryProductPage, DispensaryProductLayout);
